import React, { useState, useEffect } from 'react';
import Button from 'jsx/elements/buttons/Button';
import Warning from 'jsx/elements/messages/Warning';
import {apiPostCall, isResultOk, apiGetCall} from '../../components/special/apiCall';
import InputText from 'components/input/InputText';
import InputDropDownList from 'components/input/InputDropDownList';
import InputCheckBox from 'components/input/InputCheckBox';
import { useLocation } from 'react-router-dom';
import { useErrorContext } from './../../components/messages/ErrorBox';
import { usePageLoadingContext } from './../../components/messages/PageLoading';

const BASE_URL = process.env.REACT_APP_ILWEB_API_URL;

export const ClaimTypeEdit = (props) => {
  
  const setIsPageLoading = usePageLoadingContext();
  const setCheckErrorItems = useErrorContext();
  const params = new URLSearchParams(useLocation().search);
  const [isNew, setIsNew] = useState(true);
  const [claimTypeMethods, setClaimTypeMethods] = useState([]);
  const [data, setData] = useState({ claimTypeID : 0,
                                     name : "",
                                     claimTypeMethodID : null,
                                     allowCollateral : false,
                                     isEnabled : false,
                                     oldClaimTypeID : ""});

  const [messageBox, setMessageBox] = useState({ showMessageBox : false,
                                                 messageBoxText : "",
                                                 messageBoxType : "" })

  const loadFormData = async() => {
    setIsPageLoading(true);
    let isNew = params.get("new");
    let claimTypeID = params.get("claimtypeid");
    
    const claimTypeMethodRes = await apiGetCall(BASE_URL + '/admin/list/claimtypemethod');
    if (isResultOk(claimTypeMethodRes, setCheckErrorItems)){
        setClaimTypeMethods(claimTypeMethodRes);
    }

    if (!isNew && claimTypeID > 0){
      setIsNew(false);
      const res = await apiGetCall(BASE_URL + '/admin/claimtype/' + claimTypeID);
      if (isResultOk(res, setCheckErrorItems)){
        setData(res);
      }
    }
    setIsPageLoading(false);
  }

  useEffect(() => {
    loadFormData();
  }, []);

  const onSaveClick = async() => {
    setIsPageLoading(true);
    if (validInput()){
      let requestResult = null;
      if (isNew) {
        requestResult = await apiPostCall(BASE_URL + '/admin/claimtype/create', data);
      }
      else {
        requestResult = await apiPostCall(BASE_URL + '/admin/claimtype/change', data);
      }
      if (isResultOk(requestResult, setCheckErrorItems)) {
        props.history.goBack();
      }
    }
    setIsPageLoading(false);
  }

  function onCancelClick() {
    props.history.goBack();
  }

  function validInput() {
    if (data.name === ""){
      triggerMessageBox("Vantar heiti", "alert");
      return false;
    }
    else if (data.claimTypeMethodID === null){
      triggerMessageBox("Vantar tegund", "alert");
      return false;
    }
    else if (data.oldClaimTypeID.length > 5){
      triggerMessageBox("Tilvísunarnúmer er of langt", "alert");
      return false;
    }
    return true;
  }

  function triggerMessageBox(text, type) {
      setMessageBox({ showMessageBox : true,
        messageBoxText : text,
        messageBoxType : type });
  }

  const centerFrameDiv = {
    margin: "0 auto",
    width:"500px"
  };

  return (
    <div style={centerFrameDiv}>
      <div className="grid tight collapse480">
          <div className="col s6of12">
              {isNew && <h1 className="text-red text-32">Nýskrá kröfu tegund</h1>}
              {!isNew && <h1 className="text-red text-32">Breyta kröfu tegund</h1>}
          </div>
      </div>
      <div className="table-wrap">
          <table className="table advanced hover">
              <colgroup>
                  <col />
                  <col />
              </colgroup>
              <tbody>
                  <tr>
                      <th className="text-left">Heiti</th>
                      <td className="no-padding">
                          <div className="form">
                            <InputText name="name" value={data.name} onChange={(value) => setData({...data, name : value})}/> 
                          </div>
                      </td>
                  </tr>
                  <tr>
                      <th className="text-left">Tegund</th>
                      <td className="no-padding">
                          <div className="form">
                            <InputDropDownList list={claimTypeMethods} 
                                                keyField="itemID" 
                                                displayField="name" 
                                                defaultValue={data.claimTypeMethodID}
                                                onChange={(value) => setData({...data, claimTypeMethodID : value})}
                                                nullable={true}
                                                nullableItem={{itemID: null, name: ""}}
                                                disabled={!isNew}
                                                /> 
                          </div>
                      </td>
                  </tr>
                  {
                      claimTypeMethods.find(c => c.itemID == data.claimTypeMethodID) !== undefined && 
                      claimTypeMethods.find(c => c.itemID == data.claimTypeMethodID).data.isBond &&
                      <tr>
                        <th className="text-left">Leyfa veð</th>
                        <td className="no-padding">
                          <div className="form">
                            <InputCheckBox name="allowCollateral" value={data.allowCollateral} onChange={(value) => setData({...data, allowCollateral : value})}/>
                          </div>
                        </td>
                      </tr>
                  }
                  <tr>
                    <th className="text-left">Virk</th>
                    <td className="no-padding">
                      <div className="form">
                        <InputCheckBox name="allowCollateral" value={data.isEnabled} onChange={(value) => setData({...data, isEnabled : value})}/>
                      </div>
                    </td>
                  </tr>
                  <tr>
                      <th className="text-left">Tilvísunarnúmer (valfrjálst)</th>
                      <td className="no-padding">
                          <div className="form">
                            <InputText name="oldClaimTypeID" value={data.oldClaimTypeID} onChange={(value) => setData({...data, oldClaimTypeID : value})}/> 
                          </div>
                      </td>
                  </tr>
              </tbody>
          </table>
      </div>
      {messageBox.showMessageBox && <Warning messageHeader={messageBox.messageBoxText} onClose={() => setMessageBox({ ...messageBox, showMessageBox : false })} messageType={messageBox.messageBoxType}/>}
      <div className="grid collapse840">
        <div className="col s1of2">
          <Button text="Til baka" color="gray-light" onClick={onCancelClick}></Button>         
        </div>
        <div className="col s1of2 float-right text-right">
          <Button text="Vista" color="gray" iconright="true" onClick={onSaveClick}></Button>
        </div>
      </div>          
    </div>
  );
}

